import React, { useImperativeHandle, useState } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Hide,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalOverlay,
  Show,
  Stack,
  Text,
} from '@chakra-ui/react';
import Button from '@/components/button';

type ActionClickHandler = (_: { close: VoidFunction }) => void;

type Props = {
  title?: string;
  trigger: React.ReactNode;
  confirm: {
    title: string;
    onClick: ActionClickHandler;
  };
  cancel?: {
    title?: string;
    onClick?: ActionClickHandler;
  };
} & Omit<ModalContentProps, 'ref'>;
function ConfirmationModal(
  {
    children,
    title,
    trigger,
    confirm,
    cancel,
    ...rest
  }: React.PropsWithChildren<Props>,
  ref: any,
) {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  useImperativeHandle(
    ref,
    () => ({
      open: () => setOpen(true),
      close,
    }),
    [],
  );

  return (
    <>
      <div onClick={() => setOpen(true)}>{trigger}</div>
      <Show breakpoint="(min-width: 600px)">
        <Modal isOpen={open} isCentered onClose={close}>
          <ModalOverlay backgroundColor={'blackAlpha.300'} />
          <ModalContent maxWidth={'95vw'} {...(rest as any)}>
            <ModalHeader>{title}</ModalHeader>
            <ModalCloseButton />
            <ModalBody p={6}>
              {children}
              <Stack direction="row" mt={8}>
                <Button
                  colorScheme="red"
                  flex={1}
                  onClick={() => confirm.onClick({ close })}
                >
                  {confirm.title}
                </Button>
                <Button
                  variant={'outline'}
                  flex={1}
                  onClick={
                    cancel?.onClick ? () => cancel.onClick!({ close }) : close
                  }
                >
                  {cancel?.title || 'بستن'}
                </Button>
              </Stack>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Show>
      <Hide breakpoint="(min-width: 600px)">
        <Drawer placement="bottom" size="xl" isOpen={open} onClose={close}>
          <DrawerOverlay />
          <DrawerContent
            borderTopRadius={'2xl'}
            minHeight={'30vh'}
            maxHeight={'90vh'}
            containerProps={{ zIndex: 'goftino' }}
          >
            <DrawerHeader height={'64px'}>
              <Text fontSize={'large'}>{title}</Text>
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody p={4}>{children}</DrawerBody>
            <DrawerFooter p={4}>
              <Stack direction="row" width={'full'}>
                <Button
                  colorScheme="red"
                  flex={1}
                  size={{ base: 'md', sm: 'lg' }}
                  onClick={() => confirm.onClick({ close })}
                >
                  {confirm.title}
                </Button>
                <Button
                  variant={'outline'}
                  flex={1}
                  size={{ base: 'md', sm: 'lg' }}
                  onClick={
                    cancel?.onClick ? () => cancel.onClick!({ close }) : close
                  }
                >
                  {cancel?.title || 'بستن'}
                </Button>
              </Stack>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      </Hide>
    </>
  );
}

export default React.forwardRef(ConfirmationModal);
